<p class="missing-nuvei-banner">
    Credit card payments not connected
</p>